import { useEffect, useRef } from "react";
import { CheckCircle2, Loader2, Terminal } from "lucide-react";

const STATUS_LABELS = {
  idle: "EN ATTENTE",
  pending: "INITIALISATION",
  running: "AGENT ACTIF",
  completed: "TERMINÉ",
  partial: "PARTIEL",
  failed: "ÉCHEC",
  ready: "PRÊT",
};

export const TerminalPanel = ({ title, logs, status, emptyText, footer, testId, badgeTestId }) => {
  const bottomRef = useRef(null);
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [logs.length, footer]);

  const running = status === "running" || status === "pending";
  const done = status === "completed" || status === "partial" || status === "ready";

  return (
    <div className="h-72 bg-[#0A0A0A] flex flex-col shrink-0 rounded-xl overflow-hidden border border-slate-800" data-testid={testId}>
      <div className="px-4 py-3 border-b border-white/10 flex items-center justify-between bg-black/50 shrink-0">
        <span className="text-[10px] uppercase tracking-[0.2em] text-slate-500 font-bold flex items-center gap-2">
          <Terminal className="w-3.5 h-3.5" /> {title}
        </span>
        <span
          data-testid={badgeTestId}
          className={`px-2 py-1 rounded text-[10px] uppercase font-bold tracking-wider flex items-center gap-1.5 ${
            running ? "bg-emerald-500/10 text-[#00FF41]"
              : status === "failed" ? "bg-red-500/10 text-red-400"
              : done ? "bg-emerald-500/10 text-[#00FF41]"
              : "bg-white/5 text-slate-400"
          }`}
        >
          {running && <Loader2 className="w-3 h-3 animate-spin" />}
          {done && <CheckCircle2 className="w-3 h-3" />}
          {STATUS_LABELS[status] || status}
        </span>
      </div>
      <div className="p-4 flex-1 overflow-y-auto space-y-2 font-mono text-xs custom-scrollbar">
        {logs.length === 0 ? (
          <p className="text-slate-600">{emptyText}</p>
        ) : (
          logs.map((log, i) => (
            <div key={i} className="flex gap-3 text-slate-300 log-line">
              <span className="text-slate-600 shrink-0 w-16">[{log.time}]</span>
              <span className={`font-medium shrink-0 ${log.action === "ERREUR" ? "text-red-400" : "text-[#00FF41]"}`}>
                [{log.action}]
              </span>
              <span className="text-slate-400 break-all">{log.detail}</span>
            </div>
          ))
        )}
        {footer}
        <div ref={bottomRef} />
      </div>
    </div>
  );
};
